import React, { useState } from "react";
import { FaGraduationCap, FaBriefcase, FaCode, FaLaptopCode, FaPalette } from "react-icons/fa";
import Education from "./Education";
import Experience from "./Experience";
import Skills from "./Skills";
import Projects from "./Projects";
import Interest from "./Interest";

function ResumeLayout() {
  const [activeSection, setActiveSection] = useState("education");

  const navItems = [
    { id: "education", icon: FaGraduationCap, label: "Education" },
    { id: "experience", icon: FaBriefcase, label: "Professional Experience" },
    { id: "skills", icon: FaCode, label: "Programming Skills" },
    { id: "projects", icon: FaLaptopCode, label: "Projects" },
    { id: "interest", icon: FaPalette, label: "Interest" }
  ];

  return (
    <div className="resume-section">
      <div className="resume-header">
        <h1>Resume</h1>

        <div className="resume-divider">
          <span></span>
        </div>
      </div>

      <div className="resume-container">
        {/* left*/}
        <div className="resume-nav">
          {navItems.map((item) => (
            <div
              key={item.id}
              className={`nav-item ${activeSection === item.id ? "active" : ""}`}
              onClick={() => setActiveSection(item.id)}
            >
              <item.icon />
              <span>{item.label}</span>
            </div>
          ))}
        </div>

        {/* right */}
        <div className="resume-content">
          {activeSection === "education" && <Education />}
          {activeSection === "experience" && <Experience />}
          {activeSection === "skills" && <Skills />}
          {activeSection === "projects" && <Projects />}
          {activeSection === "interest" && <Interest />}
        </div>
      </div>
    </div>
  );
}

export default ResumeLayout;